/**
 * This file defines a context for managing login state in a React application.
 * Context provides a way to pass data through the component tree without having to pass props down manually at every level.
 * For more information, refer to the official React documentation:
 * https://react.dev/learn/passing-data-deeply-with-context
 */

import { createContext } from "react";

interface UserInfo {
    name: string;
    email: string;
    photoUrl: string;
}

interface LoginContextType {
    loggedIn: boolean;
    setLoggedIn: (value: boolean) => void;
    userInfo: UserInfo;
    setUserInfo: (updater: (prev: UserInfo) => UserInfo) => void;
    isLoading: boolean;
}

export const LoginContext = createContext<LoginContextType>({
    loggedIn: false,
    setLoggedIn: (_: boolean) => {},
    userInfo: {
        name: "",
        email: "",
        photoUrl: ""
    },
    setUserInfo: () => {},
    isLoading: true
});
